/*eslint-disable*/
import { firestore, deleteDoc, collection, getDocs, doc, updateDoc, where, getDoc, collectionGroup, setDoc, limit, orderBy, query, writeBatch, addDoc, onSnapshot, getFunctions, httpsCallable } from '../../utils/firestore'
import moment from 'moment'
import * as constants from '../../irmlib/src/common/constants'
import { getUser } from '../../redux/global'
import { getCache, addCache, getUserCountryCode } from './cache'
import { t } from 'i18n-js'

const getTemplateTypesForWmsCacheMs = 60 * 60 * 1000

const GDE_TEMPLATES = 'gdeTemplates'
const BUILDINGS = 'buildings'
const LOCATIONS = 'locations'
const CONFIG = 'config'
const COUNTRIES = 'countries'
const GDE_JOB = 'gdeJobs'
const WORKERS = 'workers'
const WORKERROLES = 'workerRoles'
const GDE_JOB_BOXES = 'gdeBoxes'
const GDE_BOX_FILES = 'gdeFiles'
const GDE_METRICS = 'gdeMetrics'
const GDE = 'gde'
const GDE_LOGIN_METRICS = 'gdeLoginMetrics'
const GDE_CUSTOMER_DATA = 'gdeCustomerData'
const GDE_PAUSE_METRICS = 'gdePauseMetrics'
const GDE_JOB_LITE = 'gdeJobTable'
const GDE_JOB_ACTIVITY = 'gdeActivities'
const GDE_JOB_SMART_CATALOG = 'smartCatalog'
const GDE_JOB_REQUEST = 'requests'
const GDE_SC_TEMPLATE = 'templates'
const GDE_SC_LOCKED_FIELD = 'lockedFields'
const GDE_JOB_IMAGES = 'images'
const GDE_SMART_CATALOG_ACTIVITIES = 'activities'
const GDE_JOB_DASHBOARD = 'dashboard'
const GDE_JOB_DISTRICT = 'district'
const GDE_JOB_DISTRICTSTAT = 'districtStat'
const GDE_SMART_CATALOG_TRANSMITTALS = 'transmittals'
const IMTIME_TIMEROLE = 'timeRole'

export const getTemplateTypesForWms = async wms => {
  const key = 'getTemplateTypesForWms'
  let data = getCache(key, wms)
  if (data) {
    return data
  }
  const standTemplateQuery = query(collection(firestore, GDE_TEMPLATES), where('templateType', '==', 'STANDARD'), where('wmsCode', 'in', [wms]))
  data = await getDocs(standTemplateQuery)
  addCache(key, wms, data, getTemplateTypesForWmsCacheMs)
  return data
}

export const getTemplatesForDeType = async (deType, wms) => {
  const templateQuery = query(collection(firestore, GDE_TEMPLATES), where('dataEntryType', '==', deType), where('wmsCode', '==', wms?.toUpperCase()))
  return getDocs(templateQuery)
}

export const getTemplates = async (deType, accLevel1 = '') => {
  const templateQuery = query(collection(firestore, GDE_TEMPLATES), where('dataEntryType', '==', deType), where('accountLevel1', '==', accLevel1?.toUpperCase()))
  return getDocs(templateQuery)
}

export const getWmsSystemFroCountry = async (countryCode) => {
  let data
  if (getUserCountryCode() === countryCode) {
    data = getCache(BUILDINGS, countryCode)
    if (data) {
      return data
    }
  }
  const buildingCollectionQuery = query(collectionGroup(firestore, BUILDINGS), where('countryCode', '==', countryCode))
  data = getDocs(buildingCollectionQuery)
  if (getUserCountryCode() === countryCode) {
    addCache(BUILDINGS, countryCode, data)
  }
  return data
}

export const getGdeConfig = async () => {
  const gdeConfig = await getDoc(doc(firestore, CONFIG, 'gde'))
  return [gdeConfig.data()?.lob, gdeConfig.data()?.assetTypes, gdeConfig.data()?.countrySettings, gdeConfig.data()?.templateType, gdeConfig.data()?.skpEncoding, gdeConfig.data()?.fileSequence, gdeConfig.data()?.fieldsSKP, gdeConfig.data()?.wmsConfig, gdeConfig.data()?.custEngmntType, gdeConfig.data()?.insideOutsideWorkflowList, gdeConfig.data()?.newWorkflow, gdeConfig.data()?.custExclusionType, gdeConfig.data()?.custExclusionReason]
}

// export const getFederalCustomers = async (custId) => {
//   const fedCustConfig = await getDoc(doc(firestore, `${CONFIG}/gde/federalCustomers`, custId.toUpperCase()))
//   return fedCustConfig.exists()

export const getFederalCustomers = async (accountLevel1, accountLevel2 = '', accountLevel3 = '') => {  // Helper function to check if document exists and isActive is true
  const normAccountLevel = (v) => {
    const s = v == null ? '' : String(v).trim()
    if (!s || s === constants.defaultSelect) return ''
    return s
  }

  const accLevel1 = normAccountLevel(accountLevel1)
  const accLevel2 = normAccountLevel(accountLevel2)
  const accLevel3 = normAccountLevel(accountLevel3)

  const checkDocument = async (docId) => {
    if (!docId) return false
    const fedCustConfig = await getDoc(doc(firestore, `${CONFIG}/gde/federalCustomers`, docId.toUpperCase()))
    if (fedCustConfig.exists()) {
      const data = fedCustConfig.data()
      return !!(data?.isActive && data?.isSC)
    }
    return false
  }

  /** Parent-only exclusions: doc id is accountLevel1 */
  const checkParentAccountLevel1 = async (al1) => {
    const base = normAccountLevel(al1)
    if (!base) return false
    if (await checkDocument(base)) return true
    if (await checkDocument(`${base}||`)) return true
    if (await checkDocument(`${base}|`)) return true
    return false
  }

  // Case 1: Only accountLevel1 is present
  if (accLevel1 !== '' && accLevel2 === '' && accLevel3 === '') {
    return await checkParentAccountLevel1(accLevel1)
  }

  // Case 2: accountLevel1 + accountLevel3 with empty level2)
  if (accLevel1 !== '' && accLevel2 === '' && accLevel3 !== '') {
    const docIdL1L3 = `${accLevel1}||${accLevel3}`
    if (await checkDocument(docIdL1L3)) return true
    return await checkParentAccountLevel1(accLevel1)
  }

  // Case 3: accountLevel1 and accountLevel2 are present, level3 empty
  if (accLevel1 !== '' && accLevel2 !== '' && accLevel3 === '') {
    const docIdd1 = `${accLevel1}|${accLevel2}|`
    if (await checkDocument(docIdd1)) return true
    return await checkParentAccountLevel1(accLevel1)
  }

  // Case 4: All three levels are present
  if (accLevel1 !== '' && accLevel2 !== '' && accLevel3 !== '') {
    const docId1 = `${accLevel1}|${accLevel2}|${accLevel3}`
    if (await checkDocument(docId1)) return true
    const docId2 = `${accLevel1}|${accLevel2}|`
    if (await checkDocument(docId2)) return true
    return await checkParentAccountLevel1(accLevel1)
  }
  return false
}

export const getOffshoreExcludedCustomers = async (accountLevel1, accountLevel2 = '', accountLevel3 = '') => {
  const normAccountLevel = (v) => {
    const s = v == null ? '' : String(v).trim()
    if (!s || s === constants.defaultSelect) return ''
    return s
  }

  const accLevel1 = normAccountLevel(accountLevel1)
  const accLevel2 = normAccountLevel(accountLevel2)
  const accLevel3 = normAccountLevel(accountLevel3)

  const checkDocument = async (docId) => {
    if (!docId) return false
    const fedCustConfig = await getDoc(doc(firestore, `${CONFIG}/gde/federalCustomers`, docId.toUpperCase()))
    if (fedCustConfig.exists()) {
      const data = fedCustConfig.data()
      return !!(data?.isActive && data?.offshoreExcl)
    }
    return false
  }

  const checkParentAccountLevel1 = async (al1) => {
    const base = normAccountLevel(al1)
    if (!base) return false
    if (await checkDocument(base)) return true
    if (await checkDocument(`${base}||`)) return true
    if (await checkDocument(`${base}|`)) return true
    return false
  }

  if (accLevel1 !== '' && accLevel2 === '' && accLevel3 === '') {
    return await checkParentAccountLevel1(accLevel1)
  }

  if (accLevel1 !== '' && accLevel2 === '' && accLevel3 !== '') {
    const docIdL1L3 = `${accLevel1}||${accLevel3}`
    if (await checkDocument(docIdL1L3)) return true
    return await checkParentAccountLevel1(accLevel1)
  }

  if (accLevel1 !== '' && accLevel2 !== '' && accLevel3 === '') {
    const docIdd1 = `${accLevel1}|${accLevel2}|`
    if (await checkDocument(docIdd1)) return true
    return await checkParentAccountLevel1(accLevel1)
  }

  if (accLevel1 !== '' && accLevel2 !== '' && accLevel3 !== '') {
    const docId1 = `${accLevel1}|${accLevel2}|${accLevel3}`
    if (await checkDocument(docId1)) return true
    const docId2 = `${accLevel1}|${accLevel2}|`
    if (await checkDocument(docId2)) return true
    return await checkParentAccountLevel1(accLevel1)
  }
  return false
}

export const getUserLevelPermission = async (docId) => {
  const permissionData = await getDoc(doc(firestore, `config/gde/userLevelPermission`, docId))
  return permissionData.data()
}

export const getLocationsForCountry = async (countryName) => {
  const locationsQuery = query(collection(firestore, LOCATIONS), where('country', '==', countryName))
  return getDocs(locationsQuery)
}

export const getCountryForDistrict = async (districtId) => {
  const districtInfo = await getDoc(doc(firestore, LOCATIONS, districtId))
  return districtInfo.data().country
}

export const getBuildingForDistrict = async (districtId) => {
  const districtInfo = await getDoc(doc(firestore, LOCATIONS, districtId))
  return districtInfo.data().buildings
}
export const getCstmrList = async (countryCode, custEngtype) => {
  const ENGTYPE = {
    'PROJECT':'Project',
  }
  const locationsQuery = query(collection(firestore, `${COUNTRIES}/${countryCode}/imtActivityGroup`), where('isActive', '==', true), where('activityGroup', '==', ENGTYPE[custEngtype]))
  return getDocs(locationsQuery)
}

export const getCountries = async () => {
  let data = getCache(COUNTRIES, COUNTRIES)
  if (data) {
    return data
  }
  data = getDocs(collection(firestore, COUNTRIES))
  addCache(COUNTRIES, COUNTRIES, data)
  return data
}

export const getCountrySkpInstance = async (countryName) => {
  const skpInstanceQuery = query(collection(firestore, COUNTRIES), where('countryName', '==', countryName))
  return getDocs(skpInstanceQuery)
}

export const getSkpInstance = async (countryCode) => {
  const skpInstanceQuery = await getDoc(doc(firestore, COUNTRIES, countryCode))
  return skpInstanceQuery.data()?.wms
}

export const getWorkerDetails = async (userId) => {
  const workerDetailsGde = await getGdeWorkerDetails(userId)
  const rawDataGde = workerDetailsGde.data()

  let data
  if (userId === getUser().workerId) {
    data = getCache(WORKERS, userId)
    if (data) {
      return data
    }
  }
  data = await getDoc(doc(firestore, WORKERS, userId))
  const rawData = data.data()

  if (rawDataGde?.gdeCountryCode !== undefined) {
    rawData.countryCode = rawDataGde.gdeCountryCode
    rawData.country = rawDataGde.gdeCountry
  }
  
  if (userId === getUser().workerId) {
    addCache(WORKERS, userId, rawData)
  }
  return rawData
}

export const getGdeWorkerDetails = async (userId) => {
  let gdeWorkerDetails
  if (userId === getUser().workerId) {
    gdeWorkerDetails = getCache(GDE, userId)
    if (gdeWorkerDetails) {
      return gdeWorkerDetails
    }
  }

  gdeWorkerDetails = getDoc(doc(firestore, WORKERS, userId, WORKERROLES, GDE))
  if (userId === getUser().workerId) {
    addCache(GDE, userId, gdeWorkerDetails)
  }
  return gdeWorkerDetails
}

export const getIMTWorkerDetails = async (userId) => {
  let imTimeWorkerDetails
  if (userId === getUser().workerId) {
    imTimeWorkerDetails = getCache(IMTIME_TIMEROLE, userId)
    if (imTimeWorkerDetails) {
      return imTimeWorkerDetails
    }
  }

  imTimeWorkerDetails = getDoc(doc(firestore, WORKERS, userId, WORKERROLES, IMTIME_TIMEROLE))
  if (userId === getUser().workerId) {
    addCache(IMTIME_TIMEROLE, userId, imTimeWorkerDetails)
  }
  return imTimeWorkerDetails
}

export const getUserNameById = async (userId) => {
  try {
    const userDoc = await getDoc(doc(firestore, `${WORKERS}`, userId))
    if (userDoc.exists()) {
      const data = userDoc.data()
      const firstName = data.firstName || ''
      const lastName = data.lastName || ''
      return `${firstName} ${lastName}`
    } else {
      return 'user not found'
    }
  } catch (error) {
    console.error('Error fetching user data :', error)
    return 'Error fetching Data'
  }
}


export const getWorkers = async () => {
  return getDocs(collection(firestore, WORKERS))
}

export const getWorkersWithDistrict = async (district) => {
  let workersQuery
  if (typeof district === 'object') {
    workersQuery = query(collection(firestore, WORKERS), where('gdeDistrict', 'in', district))
  } else {
    workersQuery = query(collection(firestore, WORKERS), where('gdeDistrict', '==', district))
  }
  return getDocs(workersQuery)
}

export const getworkersLists = async (district) => {
  const workersDoc = []
  const rolesQuery = query(collectionGroup(firestore, 'workerRoles'), where('activityFamilyId', '==', 'gde'), where('district', 'array-contains', district))
  const workerRoleDoc = await getDocs(rolesQuery)
  workerRoleDoc.forEach(async (role) => {
    workersDoc.push(getDoc(doc(firestore, role.ref.parent.parent.path)))
  })
  const workers = await Promise.all(workersDoc)
  return workers
}

export const createTemplate = async (data) => {
  return setDoc(doc(firestore, GDE_TEMPLATES, data.templateName), data)
}

export const createJob = async (data, jobId) => {
  await setDoc(doc(firestore, GDE_JOB, jobId), data)
  
  // delete data.accountLevel1Description
  // delete data.accountLevel2
  // delete data.accountLevel3
  // delete data.actionBy
  // delete data.countryCode
  // delete data.createdBy
  // delete data.isUploadCustomerDataFile
  // delete data.pickupDate
  // delete data.qualityCheck
  // delete data.recordNotifyCount
  // delete data.skpinstance
  // delete data.templateData
  // delete data.wmsCode
  // delete data.wmsInstance
  // delete data.autoTransmitAndStatus

  // return setDoc(doc(firestore, GDE_JOB_LITE, jobId), data)
}

export const getJobById = async (jobId) => {
  const rawJobByIdData = await getDoc(doc(firestore, GDE_JOB, jobId))
  const jobData = rawJobByIdData.data()
  if (jobData?.templateData === '' || jobData?.templateData === undefined) {
    let _templateName = ''
    if (jobData.templateName !== '' && jobData.templateName !== undefined) {
      _templateName = jobData.templateName
    } else {
      _templateName = jobData.standardTemplateName
    }
    
    const rawTemplateData = await getTemplateById(_templateName)
    const templateData = rawTemplateData.data()
    jobData.templateData = templateData
    await updateJob(jobId, jobData)
    return getDoc(doc(firestore, GDE_JOB, jobId))
  } else {
    return rawJobByIdData
  }
}

export const getCountryByID = async (countryId) => {
  return getDoc(doc(firestore, COUNTRIES, countryId))
}

export const getTemplateById = async (templateId) => {
  return getDoc(doc(firestore, GDE_TEMPLATES, templateId))
}
export const getTemplateById_SC = async (templateId) => {
  return getDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SC_TEMPLATE}`, templateId))
}

export const updateTemplate = async (templateId, data) => {
  return updateDoc(doc(firestore, GDE_TEMPLATES, templateId), data)
}

export const deleteTemplate = async (templateId, data) => {
  return deleteDoc(doc(firestore, GDE_TEMPLATES, templateId))
}

export const deleteJob = async (JobId, jobType, deletedBy) => {
  const collection = await getBoxesForJob(JobId)

  collection.forEach(async (docBox) => {
    const dataBox = docBox.data()
    const boxId = dataBox.boxId
    if (jobType !== 'New Box' && jobType !== 'Maintenance Box') {
      const filesForBox = await getFilesForBox(JobId, dataBox.boxId)
      filesForBox.forEach(async (docFile) => {
        const dataFile = docFile.data()
        await deleteFile(JobId, boxId, dataFile.fileNumber)
      })
    }
    await deleteBoxData(JobId, boxId)
  })

  const jobData = {
    isDeleted: true,
    deletedTs: new Date(),
    deletedBy: deletedBy,
    jobStatus: constants.jobStatus.deleted,
    autoTransmitAndStatus: constants.jobStatus.deleted
  }
  await updateDoc(doc(firestore, GDE_JOB, JobId), jobData)
  // return await deleteDoc(doc(firestore, GDE_JOB_LITE, JobId))
  // return await deleteDoc(doc(firestore, GDE_JOB, JobId))
}

export const getJobMetrics = async (JobId, data) => {
  const metricsForJob = await query(collection(firestore, GDE_METRICS), where('jobId', '==', JobId))
  return await getDocs(metricsForJob)
}
export const deleteJobMetrics = async (metricsCollectionId) => {
  const metricsData = {
    isDeleted: true,
    deletedTs: new Date(),
    isMovedToBigQuery: false,
    updatedTs: new Date(),
  }
  return updateDoc(doc(firestore, `${GDE_METRICS}/${metricsCollectionId}`), metricsData)
}

export const updateJob = async (jobId, data) => {
  await updateDoc(doc(firestore, GDE_JOB, jobId), data)

  // delete data.accountLevel1Description
  // delete data.accountLevel2
  // delete data.accountLevel3
  // delete data.actionBy
  // delete data.countryCode
  // delete data.createdBy
  // delete data.isUploadCustomerDataFile
  // delete data.pickupDate
  // delete data.qualityCheck
  // delete data.recordNotifyCount
  // delete data.skpinstance
  // delete data.templateData
  // delete data.wmsCode
  // delete data.wmsInstance
  // delete data.autoTransmitAndStatus
  // return updateDoc(doc(firestore, GDE_JOB_LITE, jobId), data)
}

export const getJobsForTemplate = async (fieldKey, templateName) => {
  const jobsForTemplatesQuery = query(collection(firestore, GDE_JOB), where(fieldKey, '==', templateName))
  return getDocs(jobsForTemplatesQuery)
}

export const getInProcessJobsForTemplate = async (templateName) => {
  const jobsForTemplatesQuery = query(collection(firestore, GDE_JOB), where('templateName', '==', templateName), where('jobStatus', 'in', [constants.jobStatus.inProgress, constants.jobStatus.assigned, constants.jobStatus.readyToTransmit, constants.jobStatus.transmitted]))
  return getDocs(jobsForTemplatesQuery)
}

export const getGdeWorkerRole = async (userId) => {
  return firestore.collection(WORKERS).doc(userId).collection('workerRoles')
}

export const getGdeWorkerRoles = async (userId) => {
  const workerRolesQueryForDocs = query(collection(firestore, `${WORKERS}/${userId}/${WORKERROLES}`))
  return getDocs(workerRolesQueryForDocs)
}

export const getJobsForUserForCurrentDate = async (customerId) => {
  const startDate = new Date(moment(new Date()).format('MM/DD/YYYY'))
  const endDate = new Date(moment(new Date()).format('MM/DD/YYYY'))
  endDate.setDate(endDate.getDate() + 1)
  const jobsQuery = query(collection(firestore, GDE_JOB), where('accountLevel1', '==', customerId.toUpperCase()), where('createdTs', '>', startDate), orderBy('createdTs', 'desc'))
  return getDocs(jobsQuery)
}

export const getQueryData = async (status) => {
  const first = query(collection(firestore, 'gdeTransactions'), where('status', '!=', status), orderBy('status'), limit(20))
  return getDocs(first)
}

export const getQueryQC = async (val) => {
  const arguments1 = []
  const userval = getUser()
  const loggedInUserDistrict = userval.district

  arguments1[0] = collection(firestore, GDE_JOB)
  let a = 0
  if (val.jobId !== constants.defaultSelect && val.jobId !== undefined) {
    arguments1[++a] = where('jobId', '==', val.jobId)
  }
  if (val.customer !== constants.defaultForAccountLevel && val.customer !== undefined) {
    arguments1[++a] = where('accountLevel1', '==', val.customer.toUpperCase())
  }

  if (val.templateNAme !== constants.defaultSelect && val.templateNAme !== undefined) {
    arguments1[++a] = where('templateName', '==', val.templateNAme)
  }

  if (val.deType !== constants.defaultSelect && val.deType !== undefined) {
    arguments1[++a] = where('dataEntryType', '==', val.deType)
  }

  const filteredArray = val.districts.filter(e => e !== constants.defaultSelect)
  val.districts = filteredArray

  if (val.districts.length > 0) {
    arguments1[++a] = where('districtId', 'in', val.districts)
  } else {
    arguments1[++a] = where('districtId', '==', loggedInUserDistrict)
  }

  // if (val.pickupDateFrom !== constants.defaultSelect) {
  //   const pickupDateFrom = new Date(`${val.pickupDateFrom} 00:00:00`)
  //   arguments1[++a] = where('pickupDate', '>=', pickupDateFrom)
  // }

  // if (val.pickupDateTo !== constants.defaultSelect) {
  //   const pickupDateTo = new Date(`${val.pickupDateTo} 23:59:59`)
  //   arguments1[++a] = where('pickupDate', '>=', pickupDateTo)
  // }

  // if (val.targetCompletiondateFrom !== constants.defaultSelect) {
  //   const targetCompletiondateFrom = new Date(`${val.targetCompletiondateFrom} 00:00:00`)
  //   arguments1[++a] = where('targetDate', '>=', targetCompletiondateFrom)
  // }

  // if (val.targetCompletiondateTo !== constants.defaultSelect) {
  //   const targetCompletiondateTo = new Date(`${val.targetCompletiondateTo} 23:59:59`)
  //   arguments1[++a] = where('targetDate', '>=', targetCompletiondateTo)
  // }
  const standTemplateQuery = query.apply(null, arguments1)
  return await getDocs(standTemplateQuery)
}

export const updateBoxStatus = async (jobId, boxId, status, isBatch, boxes, totalFiles) => {
  const batch = writeBatch(firestore)
  const actionTime = new Date()
  if (isBatch) {
    boxes.forEach(box => {
      const boxref = doc(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${box.skpBoxId}`)
      batch.update(boxref, { status: status, actionTs: actionTime })
    })
    return await batch.commit()
  } else {
    await syncBoxTotalFiles(jobId, boxId)
    return updateDoc(doc(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${boxId}`), { status: status, actionTs: actionTime})
  }
}

export const updateBoxFlow = async (jobId, status, boxes, isApprove = true) => {
  const batch = writeBatch(firestore)
  const actionTime = new Date()
  
  if (isApprove) {
    for (const boxId in boxes) {
      const boxref = doc(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${boxId}`)
      batch.update(boxref, { status: status, boxInfo: boxes[boxId], actionTs: actionTime })
    }
  } else {
    for (const boxId in boxes) {
      const boxref = doc(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${boxId}`)
      boxes[boxId].actionTs = actionTime
      batch.update(boxref, boxes[boxId])
    }
  }
  
  return await batch.commit()
}

export const updateBoxData = async (jobId, boxId, data) => {
  return updateDoc(doc(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${boxId}`), data)
}

export const deleteBoxData = async (jobId, boxId) => {
  return await deleteDoc(doc(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${boxId}`))
}


export const createNewBox = async (jobId, boxId, data) => {
  return setDoc(doc(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}`, boxId), data)
}

export const getBox = async (jobId, boxId) => {
  return getDoc(doc(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}`, boxId))
}

export const getBoxesForJob = async (jobId) => {
  const boxQuery = query(collection(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}`))
  return getDocs(boxQuery)
}

export const getBoxesForJobWithStatus = async (jobId, status) => {
  const boxQuery = query(collection(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}`), where('status', '==', status))
  return getDocs(boxQuery)
}

export const getBoxesForQC = async (jobId) => {
  const boxQuery = query(collection(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}`), where('status', 'in', [constants.boxStatus.readyForQc, constants.boxStatus.qcInProcess]))
  return getDocs(boxQuery)
}

export const getFilesForBox = async (jobId, boxId) => {
  const fileQuery = query(collection(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${boxId}/${GDE_BOX_FILES}`))
  return getDocs(fileQuery)
}

export const syncBoxTotalFiles = async (jobId, boxId) => {
  const filesSnapshot = await getFilesForBox(jobId, boxId)
  const filesCount = filesSnapshot.docs.length
  await updateBoxData(jobId, boxId, { totalFiles: filesCount })
  return filesCount
}

export const getFileCountForJob = async (jobId) => {
  let totalFileCount = 0
  const collection1 = await getBoxesForJob(jobId)
  const boxList = []
  collection1.forEach((doc) => {
    boxList.push({
      boxId: doc.id,
    })
  })
  // 647: getting the total File count from all the boxes in a job
  for (let i = 0; i < boxList.length; i++) {
    const boxId = boxList[i]?.boxId
    const fileQuery = query(collection(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${boxId}/${GDE_BOX_FILES}`))
    const snapshot = await getDocs(fileQuery)
    totalFileCount = totalFileCount + snapshot.docs.length
  }
  return totalFileCount
}

export const createFileInfo = async (data, jobId, boxId, fileId) => {
   return setDoc(doc(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${boxId}/${GDE_BOX_FILES}`, fileId), data)
}

export const createBoxInfo = async (data, jobId, boxName) => {
  return setDoc(doc(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${boxName}`, boxName), data)
}

export const totalUserFiles = async (jobId, data) => {
  return updateDoc(doc(firestore, `${GDE_JOB}`, jobId), data)
}

export const updateFile = async (jobId, boxId, fileId, fileData) => {
  return updateDoc(doc(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${boxId}/${GDE_BOX_FILES}`, fileId), fileData)
}

export const updateFileAsBatch = async (jobId, boxId, fileList, customerId) => {
  const batch = writeBatch(firestore)
  const actionTime = new Date()
  fileList.forEach((file, index) => {
    const count = `${index + 1}`
    const fileId = file.fileId || count.padStart(5, '0')
    delete file.Sr_No
    if (file.customerId === undefined || file.customerId === '') {
      file.customerId = customerId
    }
    
    const fileData = {
      actionTs: actionTime,
      fileInfo: file
    } 
    const fileRef = doc(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${boxId}/${GDE_BOX_FILES}/${fileId}`)
    batch.update(fileRef, fileData)
  })
  return await batch.commit()
}

export const updateBox = async (jobId, boxName, boxData) => {
  // const boxObject = JSON.parse(JSON.stringify(boxData))
  // delete boxObject?.boxInfo?.Sr_No
  // delete boxObject?.boxInfo?.id
  return updateDoc(doc(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}`, boxName), boxData)
}

export const deleteFile = async (jobId, boxId, fileId) => {
  return deleteDoc(doc(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${boxId}/${GDE_BOX_FILES}/${fileId}`))
}

export const createFile = async (jobId, boxId, fileId, fileData) => {
  return setDoc(doc(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${boxId}/${GDE_BOX_FILES}`, fileId), fileData)
}

export const getTransmittal = async (transmittalId) => {
  const transmittalDoc = await getDoc(doc(firestore, 
    `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_TRANSMITTALS}`, 
    transmittalId)
  ) 
  const data = transmittalDoc.data()
  return data
}

export const fetchTransmittalsByBatchId = async (batchId) => {
  const q = query(collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_TRANSMITTALS}`), where('batchId', '==', batchId));
  const querySnapshot = await getDocs(q);
  const filteredData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  return filteredData;
}

export const listenTransmittalsByBatchId = (mode, batchId, setData) => {
  if (!batchId) return () => {}  // no-op unsubscribe if no batchId

  const q = query(
    collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_TRANSMITTALS}`),
    where('batchId', '==', batchId)
  )
  if (mode === 'normal') {
    return getDocs(q)
  } else if (mode === 'listener') {
  const unsubscribe = onSnapshot(q, (snapshot) => {
    const filteredData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
    setData(snapshot)
  }, (error) => {
    console.error('Listener error:', error)
  })
    return unsubscribe
  }

}

export const deleteTransmittal = async (transmittalId) => {
  return deleteDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_TRANSMITTALS}`, transmittalId))
}

export const updateTransmittal = async (transmittalId, data) => {
  return updateDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_TRANSMITTALS}`, transmittalId), data)
}

export const updateFilesForBox = async (jobId, boxId, data) => {
  const batch = writeBatch(firestore)
  for (const fileKey in data) {
    const fileRef = doc(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${boxId}/${GDE_BOX_FILES}/${fileKey}`)
    batch.update(fileRef, { fileInfo: data[fileKey] })
  }

  return await batch.commit()
}

export const moveFilesForBox = async (jobId, oldBoxId, newBoxId, data, boxData) => {
  const batch = writeBatch(firestore)
  for (const fileKey in data) {
    const oldFileId = data[fileKey].oldFileId
    delete data[fileKey].oldFileId
    delete data[fileKey].tableData
    delete data[fileKey].Sr_No
    const fileData = {
      actionTs: new Date(),
      dataEntryUser: boxData.dataEntryUser,
      fileInfo: data[fileKey],
      fileNumber: fileKey,
      jobId: jobId,
      verificationUser: boxData.verificationUser,
      status: data[fileKey].status
    }
    const createFileRef = doc(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${newBoxId}/${GDE_BOX_FILES}/${fileKey}`)
    batch.set(createFileRef, fileData)
    const deleteFileRef = doc(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${oldBoxId}/${GDE_BOX_FILES}/${oldFileId}`)
    batch.delete(deleteFileRef)
  }


  return await batch.commit()
}

export const getTemplateFields = async (tempName) => {
  const templateQuery = query(doc(firestore, `${GDE_TEMPLATES}/${tempName}`))
  return getDoc(templateQuery)
}

export const getTemplateType = async () => {
  const templateType = query(collection(firestore, GDE_TEMPLATES))
  return getDocs(templateType)
}

export const getUserList = async (userIdArray) => {
  const userQuery = query(collection(firestore, WORKERS), where('workerId', 'in', userIdArray))
  return getDocs(userQuery)
}

export const getUsers = async (userIdArray) => {
  const userQuery = query(collection(firestore, WORKERS))
  return getDocs(userQuery)
}

export const getDistricts = async () => {
  const locationsQuery = query(collection(firestore, LOCATIONS))
  return getDocs(locationsQuery)
}

export const getDistrictsByCountry = async (countryName) => {
  const locationsQuery = query(collection(firestore, LOCATIONS), where('country', '==', countryName))
  return getDocs(locationsQuery)
}

export const getQueryDataJob = async (val, user) => {
  const userval = getUser()
  const loggedInUserDistrict = userval.district
  if (val.jobStatus === 'Assigned,In Process' || val.jobStatus === 'Pending, Assigned, In Process') {
    if (val.jobStatus === 'Assigned,In Process') {
      const arguments1 = []
      arguments1[0] = collection(firestore, GDE_JOB)
      let a = 0
      arguments1[++a] = where('jobStatus', 'in', [constants.jobStatus.assigned, constants.jobStatus.inProgress])
      if (user) {
        arguments1[++a] = where('assignedUserList', 'array-contains', user)
      }
      arguments1[++a] = where('districtId', '==', loggedInUserDistrict)
      const standTemplateQuery = query.apply(null, arguments1)
      return await getDocs(standTemplateQuery)
    }
    if (val.jobStatus === 'Pending, Assigned, In Process') {
      const arguments1 = []
      arguments1[0] = collection(firestore, GDE_JOB)
      let a = 0
      arguments1[++a] = where('jobStatus', 'in', [constants.jobStatus.assigned, constants.jobStatus.inProgress, constants.jobStatus.pending])
      if (user) {
        arguments1[++a] = where('assignedUserList', 'array-contains', user)
      }
      arguments1[++a] = where('districtId', '==', loggedInUserDistrict)
      const standTemplateQuery = query.apply(null, arguments1)
      return await getDocs(standTemplateQuery)
    }
  } else {
    const arguments1 = []
    arguments1[0] = collection(firestore, GDE_JOB)
    let a = 0
    if (val.initialStatus === 'NoApprove' && val.jobStatus !== 'Transmitted') {
      arguments1[++a] = where('jobStatus', '!=', constants.jobStatus.transmitted)
    }
    if (val.jobStatus === constants.jobStatus.transmitted) {
      arguments1[++a] = where('jobStatus', '==', constants.jobStatus.transmitted)
    }
    if (val.jobStatus !== constants.defaultSelect) {
      arguments1[++a] = where('jobStatus', '==', val.jobStatus)
    }
    if (val.customer !== constants.defaultForAccountLevel && val.customer !== constants.defaultSelect) {
      arguments1[++a] = where('accountLevel1', '==', val.customer.toUpperCase())
    }

    if (val.templateNAme !== constants.defaultSelect) {
      arguments1[++a] = where('templateName', '==', val.templateNAme)
    }

    if (val.deType !== constants.defaultSelect) {
      arguments1[++a] = where('dataEntryType', '==', val.deType)
    }

    const filteredArray = val.districts.filter(e => e !== constants.defaultSelect)
    val.districts = filteredArray

    if (val.districts.length > 0) {
      arguments1[++a] = where('districtId', 'in', val.districts)
    } else {
      arguments1[++a] = where('districtId', '==', loggedInUserDistrict)
    }
    if (val.pickupDateFrom === constants.defaultSelect && val.pickupDateFrom === constants.defaultSelect && val.targetCompletiondateFrom === constants.defaultSelect && val.targetCompletiondateTo === constants.defaultSelect) {
      if (val.pickupDateFrom !== constants.defaultSelect) {
        const pickupDateFrom = new Date(`${val.pickupDateFrom} 00:00:00`)
        arguments1[++a] = where('pickupDate', '>=', pickupDateFrom)
      }

      if (val.pickupDateTo !== constants.defaultSelect) {
        const pickupDateTo = new Date(`${val.pickupDateTo} 23:59:59`)
        arguments1[++a] = where('pickupDate', '<=', pickupDateTo)
      }
    }
    if (val.pickupDateFrom !== constants.defaultSelect && val.pickupDateFrom !== constants.defaultSelect && val.targetCompletiondateFrom === constants.defaultSelect && val.targetCompletiondateTo === constants.defaultSelect) {
      if (val.pickupDateFrom !== constants.defaultSelect) {
        const pickupDateFrom = new Date(`${val.pickupDateFrom} 00:00:00`)
        arguments1[++a] = where('pickupDate', '>=', pickupDateFrom)
      }

      if (val.pickupDateTo !== constants.defaultSelect) {
        const pickupDateTo = new Date(`${val.pickupDateTo} 23:59:59`)
        arguments1[++a] = where('pickupDate', '<=', pickupDateTo)
      }
    }
    if (val.pickupDateFrom === constants.defaultSelect && val.pickupDateFrom === constants.defaultSelect && val.targetCompletiondateFrom !== constants.defaultSelect && val.targetCompletiondateTo !== constants.defaultSelect) {
      if (val.targetCompletiondateFrom !== constants.defaultSelect) {
        const targetCompletiondateFrom = new Date(`${val.targetCompletiondateFrom} 00:00:00`)
        arguments1[++a] = where('targetDate', '>=', targetCompletiondateFrom)
      }

      if (val.targetCompletiondateTo !== constants.defaultSelect) {
        const targetCompletiondateTo = new Date(`${val.targetCompletiondateTo} 23:59:59`)
        arguments1[++a] = where('targetDate', '<=', targetCompletiondateTo)
      }
    }

    if (user) {
      arguments1[++a] = where('assignedUserList', 'array-contains', user)
    }
    const standTemplateQuery = query.apply(null, arguments1)
    return await getDocs(standTemplateQuery)
  }
}

// export const getQueryDataJob2 = async (val, user) => {
//   const userval = getUser()
//   const loggedInUserDistrict = userval.district
//   if (val.jobStatus === 'Assigned,In Process' || val.jobStatus === 'Pending, Assigned, In Process') {
//     if (val.jobStatus === 'Assigned,In Process') {
//       const arguments1 = []
//       arguments1[0] = collection(firestore, GDE_JOB)
//       let a = 0
//       arguments1[++a] = where('jobStatus', 'in', [constants.jobStatus.assigned, constants.jobStatus.inProgress])
//       if (user) {
//         arguments1[++a] = where('assignedUserList', 'array-contains', user)
//       }
//       arguments1[++a] = where('districtId', '==', loggedInUserDistrict)
//       const standTemplateQuery = query.apply(null, arguments1)
//       return await getDocs(standTemplateQuery)
//     }
//     if (val.jobStatus === 'Pending, Assigned, In Process') {
//       const arguments1 = []
//       arguments1[0] = collection(firestore, GDE_JOB)
//       let a = 0
//       arguments1[++a] = where('jobStatus', 'in', [constants.jobStatus.assigned, constants.jobStatus.inProgress, constants.jobStatus.pending])
//       if (user) {
//         arguments1[++a] = where('assignedUserList', 'array-contains', user)
//       }
//       arguments1[++a] = where('districtId', '==', loggedInUserDistrict)
//       const standTemplateQuery = query.apply(null, arguments1)
//       return await getDocs(standTemplateQuery)
//     }
//   } else {
//     // filter options
//     const arguments1 = []
//     arguments1[0] = collection(firestore, GDE_JOB)
//     let a = 0
    
//     if (user) {
//       // filter for my jobs
//       if (val.initialStatus === 'NoApprove') {
//         arguments1[++a] = where('jobStatus', '!=', constants.jobStatus.transmitted)
//       }
//       if (val.userName !== constants.defaultSelect && val.userName !== undefined) {
//         arguments1[++a] = where('assignedUserList', 'array-contains', val.userName)
//       } else {
//         arguments1[++a] = where('assignedUserList', 'array-contains', user)
//       }
//       addOtherfilters(val, arguments1, a, loggedInUserDistrict, user)
//       if (val.templateNAme !== constants.defaultSelect) {
//         arguments1[++a] = where('templateName', '==', val.templateNAme)
//       } 
//     } else {
//       // filter for all jobs
//       if (val.initialStatus === 'NoApprove' && val.jobStatus !== 'Transmitted') {
//         arguments1[++a] = where('jobStatus', '!=', constants.jobStatus.transmitted)
//       }
//       if (val.userName !== constants.defaultSelect && val.userName !== undefined) {
//         arguments1[++a] = where('assignedUserList', 'array-contains', val.userName)
//       }

//       addOtherfilters(val, arguments1, a, loggedInUserDistrict)

//       if (val.templateNAme !== constants.defaultSelect) {
//         arguments1[++a] = where('templateName', '==', val.templateNAme)
//       } 
//     }
//     if (val.jobStatus !== constants.defaultSelect) {
//       arguments1[++a] = where('jobStatus', '==', val.jobStatus)
//     } 
//     const standTemplateQuery = query.apply(null, arguments1)
//     return await getDocs(standTemplateQuery)
//   }
// }

// const addOtherfilters = (val, arguments1, a, loggedInUserDistrict, user) => {
//   // if (val.jobStatus === constants.jobStatus.transmitted && val.pickupDateFrom !== constants.defaultSelect && val.pickupDateTo !== constants.defaultSelect) {
//   //   arguments1[++a] = where('jobStatus', '==', constants.jobStatus.transmitted)
//   // } 
  
//   if (val.jobStatus !== constants.defaultSelect) {
//     arguments1[++a] = where('jobStatus', '==', val.jobStatus)
//   } 
  
//   if (val.customer !== constants.defaultForAccountLevel && val.customer !== undefined && val.customer !== constants.defaultSelect) {
//     arguments1[++a] = where('accountLevel1', '==', val.customer.toUpperCase())
//   }

//   if (val.orderNumber !== constants.defaultForAccountLevel && val.orderNumber !== constants.defaultSelect) {
//     arguments1[++a] = where('orderNumber', '==', val.orderNumber)
//   }
 
//   if (val.deType !== constants.defaultSelect) {
//     arguments1[++a] = where('dataEntryType', '==', val.deType)
//   }
//   const filteredArray = val.districts.filter(e => e !== constants.defaultSelect)
//   val.districts = filteredArray

//   if (val.districts.length > 0) {
//     arguments1[++a] = where('districtId', 'in', val.districts)
//   } else {
//     arguments1[++a] = where('districtId', '==', loggedInUserDistrict)
//   }
// }
export const getQueryTemplates2 = async (val) => {
  const arguments1 = []
  arguments1[0] = collection(firestore, GDE_TEMPLATES)
  let a = 0
  if (val.country !== constants.defaultSelect) {
    arguments1[++a] = where('countryCode', '==', val.country)
  }
  if (val.accountLevel1 !== constants.defaultForAccountLevel) {
    arguments1[++a] = where(constants.accountLevel1, '==', val.accountLevel1.toUpperCase())
  }
  if (val.accountLevel2 !== constants.defaultForAccountLevel) {
    arguments1[++a] = where(constants.accountLevel2, '==', val.accountLevel2.toUpperCase())
  }
  if (val.accountLevel3 !== constants.defaultForAccountLevel) {
    arguments1[++a] = where(constants.accountLevel3, '==', val.accountLevel3.toUpperCase())
  }
  if (val.templateType !== constants.defaultSelect) {
    arguments1[++a] = where(constants.dataEntryType, '==', val.templateType)
  }
  if (val.templateName !== constants.defaultSelect) {
    arguments1[++a] = where(constants.templateName, '==', val.templateName)
  }
  if (val.wms !== constants.defaultSelect) {
    arguments1[++a] = where(constants.wmsCode, '==', val.wms)
  }
  if (val.templateType !== constants.defaultSelect) {
    arguments1[++a] = where(constants.dataEntryType, '==', val.templateType)
  }
  if (val.templateName !== constants.defaultSelect) {
    arguments1[++a] = where(constants.templateName, '==', val.templateName)
  }
  if (val.accountLevel3 !== constants.defaultForAccountLevel) {
    arguments1[++a] = where(constants.accountLevel3, '==', val.accountLevel3.toUpperCase())
  } else if (val.accountLevel2 !== constants.defaultForAccountLevel) {
    arguments1[++a] = where(constants.accountLevel2, '==', val.accountLevel2.toUpperCase())
  } else if (val.accountLevel1 !== constants.defaultForAccountLevel) {
    arguments1[++a] = where(constants.accountLevel1, '==', val.accountLevel1.toUpperCase())
  } else if (val.wms !== constants.defaultSelect) {
    arguments1[++a] = where(constants.wmsCode, '==', val.wms)
  } else if (val.country !== constants.defaultSelect) {
    arguments1[++a] = where('countryCode', '==', val.country)
  }

  const standTemplateQuery = query.apply(null, arguments1)
  return getDocs(standTemplateQuery)
}



export const getQueryTemplates = async (val) => {
  const arguments1 = []
  arguments1[0] = collection(firestore, GDE_TEMPLATES)
  let a = 0
  if (val.country !== constants.defaultSelect) {
    arguments1[++a] = where('countryCode', '==', val.country)
  }
  if (val.accountLevel1 !== constants.defaultForAccountLevel) {
    arguments1[++a] = where(constants.accountLevel1, '==', val.accountLevel1.toUpperCase())
  }
  if (val.accountLevel2 !== constants.defaultForAccountLevel) {
    arguments1[++a] = where(constants.accountLevel2, '==', val.accountLevel2.toUpperCase())
  }
  if (val.accountLevel3 !== constants.defaultForAccountLevel) {
    arguments1[++a] = where(constants.accountLevel3, '==', val.accountLevel3.toUpperCase())
  }
  if (val.templateType !== constants.defaultSelect) {
    arguments1[++a] = where(constants.dataEntryType, '==', val.templateType)
  }
  if (val.templateName !== constants.defaultSelect) {
    arguments1[++a] = where(constants.templateName, '==', val.templateName)
  }
  if (val.wms !== constants.defaultSelect) {
    arguments1[++a] = where(constants.wmsCode, '==', val.wms)
  }

  if (val.dateCreatedFrom !== constants.defaultSelect) {
    const dateCreatedFrom = new Date(`${val.dateCreatedFrom} 00:00:00`)
    arguments1[++a] = where('createdTs', '>=', dateCreatedFrom)
  }

  if (val.dateCreatedTo !== constants.defaultSelect) {
    const dateCreatedTo = new Date(`${val.dateCreatedTo} 23:59:59`)
    arguments1[++a] = where('createdTs', '<=', dateCreatedTo)
  }

  const standTemplateQuery = query.apply(null, arguments1)
  return getDocs(standTemplateQuery)
}

export const getTemplateTypes = async (wms) => {
  const key = 'getTemplateTypes'
  let data = getCache(key, key)
  if (data) {
    return data
  }

  const standTemplateQuery = query(collection(firestore, GDE_TEMPLATES), where('templateType', '==', 'STANDARD'))
  data = getDocs(standTemplateQuery)
  addCache(key, key, data, getTemplateTypesForWmsCacheMs)
  return data
}

export const updateBoxDetails = async (jobId, boxId, data) => {
  return setDoc(doc(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${boxId}`), data)
}

export const saveMetricsData = async (data) => {
  if (data.activityType === 'keystroke') {
    const workerLocation = getCache('wrokLocation', getUser()?.workerId)
    data.isMovedToBigQuery = false
    data.updatedTs = new Date()
    data.workerDistrict = workerLocation.district
    data.workerBuilding = workerLocation.building
  }
  if (data.activityType === 'retransmit') {
    data.updatedTs = new Date()
    data.workerFirstName = getUser().firstName
    data.workerId = getUser()?.workerId
    data.workerLastName = getUser()?.lastName
  }
  return addDoc(collection(firestore, GDE_METRICS), data)
}

export const savePauseMetrics = async (data, metricsId) => {
  return setDoc(doc(firestore, GDE_PAUSE_METRICS, metricsId), data)
}

export const savePauseMetricsSummary = async (data, metricsId) => {
  return setDoc(doc(firestore, GDE_PAUSE_METRICS, metricsId), data)
}

export const updatePauseMetricsSummary = async (data, metricsId) => {
  return updateDoc(doc(firestore, GDE_PAUSE_METRICS, metricsId), data)
}

export const getPauseMetricsSummary = async (metricsId) => {
  const rawData = await getDoc(doc(firestore, GDE_PAUSE_METRICS, metricsId))
  const summary = rawData.data()
  return summary
}

export const getFilesforDoNotDuplicate = async (jobId, field, value) => {
  const doNotDuplicateQuery = query(collectionGroup(firestore, GDE_BOX_FILES), where('jobId', '==', jobId), where(`fileInfo.${field}`, '==', value))
  return getDocs(doNotDuplicateQuery)
}

export const getMetricsForJobBox = async (jobId, boxId) => {
  const metricsForJob = await query(collection(firestore, GDE_METRICS), where('jobId', '==', jobId), where('boxId', '==', boxId))
  return await getDocs(metricsForJob)
}

export const updateMetricsForJobBox = async (metricsCollectionId, metricsData) => {
  metricsData.isMovedToBigQuery = false
  return updateDoc(doc(firestore, `${GDE_METRICS}/${metricsCollectionId}`), metricsData)
}

export const getLoginMetrics = async (workerId, metricsId) => {
  let data = getCache(GDE_LOGIN_METRICS, metricsId)
  if (data) {
    return data
  }
  data = await getDocs(
    query(
      collection(firestore, GDE_METRICS),
      where('workerId', '==', workerId),
      where('metricsId', '==', metricsId)
    )
  )
  addCache(GDE_LOGIN_METRICS, metricsId, data)
  return data
}

export const updateMetricsForLogin = async (metricsData) => {
  metricsData.isMovedToBigQuery = false
  return updateDoc(doc(firestore, GDE_METRICS, metricsData.metricsCollectionId), metricsData)
}

export const createUploadCollection = async (jobId, fileUniqueId, data) => {
  return setDoc(doc(firestore, `${GDE_JOB}/${jobId}/${GDE_CUSTOMER_DATA}`, fileUniqueId), data)
}

export const getUploadCollection = async (jobId) => {
  const customerUploadData = await query(collection(firestore, `${GDE_JOB}/${jobId}/${GDE_CUSTOMER_DATA}`))
  return await getDocs(customerUploadData)
}

export const deleteUploadCollection = async (jobId, fileUniqueId) => {
  return await deleteDoc(doc(firestore, `${GDE_JOB}/${jobId}/${GDE_CUSTOMER_DATA}/${fileUniqueId}`))
}

export const getUploadCollectionById = async (jobId, fileUniqueId) => {
  return getDoc(doc(firestore, `${GDE_JOB}/${jobId}/${GDE_CUSTOMER_DATA}`, fileUniqueId))
}

export const updateWmsInstance = async (workerId, wmsInstance) => {
  const workerData2 = {
    wmsInstance: wmsInstance,
  }
  return updateDoc(doc(firestore, `workers/${workerId}/workerRoles/gde`), workerData2)
}

export const updateWorkingLocation = async (workerId, workingLocation) => {
  const data = {
    workingLocation: workingLocation,
  }
  return updateDoc(doc(firestore, `workers/${workerId}/workerRoles/gde`), data)
}

export const getWorkerRoleGde = async (workerId) => {
  const workerDetailsGde = await getDoc(doc(firestore, `workers/${workerId}/workerRoles/gde`))
  return workerDetailsGde.data()
}

export const getAppVersion = async () => {
  const gdeConfig = await getDoc(doc(firestore, CONFIG, 'gde'))
  return gdeConfig.data().version
}

export const createActivity = async (documentId, data) => {
  return setDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_REQUEST}`, documentId), data)
}

export const createSmartCatalogTemplate = async (documentId, data) => {
  return setDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SC_TEMPLATE}`, documentId), data)
}

export const createBoxTransmittals = async (documentId, data) => {
  return setDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_TRANSMITTALS}`, documentId), data)
}

export const createSmartLockedFields = async (data) => {
  return addDoc(collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SC_LOCKED_FIELD}`), data)
}

export const getLockedTemplateFields = async (customerId, lockField) => {
  const collectionRef = query(collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SC_LOCKED_FIELD}`), where('customer', '==', customerId), where('templateField', '==', lockField))
  return await getDocs(collectionRef)
}
export const getLockedFieldsListner = async (customerId, lockField, setData, setDoc) => {
  const collectionRef = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SC_LOCKED_FIELD}`) 
  const querySnapshot = query(collectionRef, where('customer', '==', customerId))
  const unsubscribe = onSnapshot(querySnapshot, (snapshot) => {
    const updatedData = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }))
    const lockedFieldData = updatedData.find(item => (item.customer === customerId && item.templateField === lockField))
    const docId = lockedFieldData?.id
    setDoc(docId)
    const lockedField = lockedFieldData?.[lockField] || []
    // const result = lockedGF.map(obj => ({ value: obj.value, workerId: obj.workerId }))
    setData(lockedField)
  })
  return unsubscribe
}

export const updateLocked = (documentId, selectedField, date, data) => {
  const exactPath = doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SC_LOCKED_FIELD}`, documentId)
  return updateDoc(exactPath, { [`${selectedField}`]: data, updatedTS: date })
}

export const getStandardTemplateName = (wmsInstance, templateType, assetType) => {
  let templateName = ''
  if (templateType === 'New') {
    templateName = `${wmsInstance.toLowerCase()}StandardNewFile`
    if (assetType === 'Single Box' || assetType === 'Multiple Boxes') {
      templateName = `${wmsInstance.toLowerCase()}StandardNewBox`
    } else if (assetType === 'Box Transmittal' ) {
      templateName = `${wmsInstance.toLowerCase()}StandardNewBoxTransmittal`
    }
  } else if (templateType === 'Maintenance') {
    templateName = `${wmsInstance.toLowerCase()}StandardMaintenanceFile`
    if (assetType === 'Single Box' || assetType === 'Multiple Boxes') {
      templateName = `${wmsInstance.toLowerCase()}StandardMaintenanceBox`
    } else if (assetType === 'Box Transmittal' ) {
      templateName = `${wmsInstance.toLowerCase()}StandardMaintenanceBoxTransmittal`
    }
  }
  return templateName
}

export const getRequests = async (formValues) => {
  const conditions = []
  const templateType = formValues?.templateType
  const assetType = formValues?.assetType
  const wmsInstance = formValues?.wmsInstance
  const accountLevel1 = formValues?.accountLevel1
  const accountLevel2 = formValues?.accountLevel2
  const accountLevel3 = formValues?.accountLevel3
  conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_SC_TEMPLATE)
  let index = 0
  // conditions[++index] = where('srcSystem', '==', 'gde')
  // conditions[++index] = where('isTemplate', '==', true)
  conditions[++index] = where('isActive', '==', true)
  if (accountLevel1 !== '') {
    conditions[++index] = where('accountLevel1', '==', accountLevel1.toUpperCase())
  }
  if (accountLevel2 && accountLevel2 !== '') {
    conditions[++index] = where('accountLevel2', '==', accountLevel2.toUpperCase())
  }
  if (accountLevel3 && accountLevel3 !== '') {
    conditions[++index] = where('accountLevel3', '==', accountLevel3.toUpperCase())
  }

  if (wmsInstance !== '' && wmsInstance !== undefined) {
    const templateName = getStandardTemplateName(wmsInstance, templateType, assetType)
    conditions[++index] = where('templateName', '==', templateName)
  } else {
    if (assetType && assetType !== constants.defaultSelect && assetType !== '') {
      conditions[++index] = where('assetType', '==', formValues.assetType)
    }
    if (templateType && templateType !== constants.defaultSelect && templateType !== '') {
      conditions[++index] = where('templateType', '==', templateType)
    }
  }
  const standTemplateQuery = query.apply(null, conditions)
  return await getDocs(standTemplateQuery)
}

export const getGlobalTransmittalTemplates = async (selectedWmsInstance, accountLevelone, templateTypeSelected) => {
  const conditions = []
  const templateType = templateTypeSelected
  const assetType = 'Box Transmittal'
  const wmsInstance = selectedWmsInstance
  const accountLevel1 = accountLevelone
  if (wmsInstance !== '' && wmsInstance !== undefined && wmsInstance !== t('demo.noText')) {
    conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_SC_TEMPLATE)
    let index = 0

    conditions[++index] = where('isActive', '==', true)
    if (accountLevel1 !== '') {
      conditions[++index] = where('accountLevel1', 'in', ['GLOBALTEMPLATE', accountLevel1.toUpperCase()])
    }

    if (wmsInstance !== '') {
      conditions[++index] = where('wmsCode', '==', wmsInstance.toUpperCase())
    }
    const templateName = getStandardTemplateName(wmsInstance, templateType, assetType)
    conditions[++index] = where('templateName', '==', templateName)
    const standTemplateQuery = query.apply(null, conditions)
    return await getDocs(standTemplateQuery)
  }
}

export const updateSmartCatalogTemplate = async (templateId, data) => {
  await updateDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_SC_TEMPLATE, templateId), data)
  return true
}

export const saveActivityImages = async (data) => {
  const result = await addDoc(collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`), data)
  return result.id
}

export const updateActivityData = async (activityId, data) => {
  await updateDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_ACTIVITIES}`, activityId), data)
}

export const getActivityByID = async (activityId) => {
  const workerDetailsGde = await getDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_ACTIVITIES}`, activityId))
  return workerDetailsGde.data()
}

export const createClonedActivity = async (data) => {
  return addDoc(collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_ACTIVITIES}`), data)
}

export const getImagesAndUpdate = async (activityId, data, initialStatus) => {
  const imagesSnapshot = query(
    collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`), 
    where('activityId', '==', activityId),
    where('isActive', '==', true) // Uncomment after testing
  )

  const images = await getDocs(imagesSnapshot)
  const imagesDocs = images.docs

  const BATCH_SIZE = 10 
  for (let i = 0; i < imagesDocs.length; i += BATCH_SIZE) {
    const batch = imagesDocs.slice(i, i + BATCH_SIZE).map(image => {
      return updateDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`, image.id), data)
    })

    await Promise.all(batch)
  }

  const activityDataToUpdate = {
    status: initialStatus || constants.activityStatus.completed,
    updateTS: (new Date()).toISOString(),
    imgFailCount: 0,
    imgProcessCount: 0,
    isIdpFail: false,
  }
  await updateActivityData(activityId, activityDataToUpdate)
}

export const imagesListner = async (setData, activityId) => {
  const collectionRef = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`)
  const querySnapshot = query(collectionRef, where('activityId', '==', activityId), orderBy('createTS', 'asc'))
  const unsubscribe = onSnapshot(querySnapshot, (snapshot) => {
    const updatedData = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }))
    setData(updatedData)
  })
  return unsubscribe
}

export const statusListner = async (setData, requestId) => {
  const collectionRef = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`)
  const querySnapshot = query(collectionRef, where('requestId', '==', requestId))
  const unsubscribe = onSnapshot(querySnapshot, (snapshot) => {
    const updatedData = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }))
    setData(updatedData)
  })
  return unsubscribe
}

export const updateImage = async (id, data) => {
  await updateDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`, id), data)
}

export const bulkDeleteImages = async (activityId, imageIds = []) => {
  if (!activityId || !Array.isArray(imageIds) || imageIds.length === 0) {
    return
  }

  const functions = getFunctions()
  const bulkImageDelete = httpsCallable(functions, 'grpGde-smartCatalogBulkImageDelete')
  const response = await bulkImageDelete({
      activityId,
      imageIds,
  })

  if (response?.data?.error) {
    throw new Error(response.data.error)
  }

  return response?.data
}

export const countListner = async (setData, requestId) => {
  const collectionRef = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_REQUEST}`)
  const querySnapshot = query(collectionRef, where('requestId', '==', requestId))
  const unsubscribe = onSnapshot(querySnapshot, (snapshot) => {
    const updatedData = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }))
    setData(updatedData)
  })
  return unsubscribe
}

export const boxesListener = async (setData, requestId) => {
  const collectionRef = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_ACTIVITIES}`)
  const querySnapshot = query(collectionRef, where('requestId', '==', requestId))
  const unsubscribe = onSnapshot(querySnapshot, (snapshot) => {
    const updatedData = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }))
    setData(updatedData)
  })
  return unsubscribe
}

export const batchUpdateBoxAsException= async (pendingRequests, exceptionNote)=>{
    const CHUNK_SIZE = constants.MAX_CHUNK_SIZE || 400
   // iterate the requests to divide into chunks
   for(let i=0; i < pendingRequests.length; i = i+CHUNK_SIZE){
     const chunkRequests = pendingRequests.slice(i,i+CHUNK_SIZE)
     const batch = writeBatch(firestore)
     chunkRequests.forEach(({activityId})=>{
      //doc ref
      const refDoc = doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_ACTIVITIES}`, activityId)
      //update payload
      let requestExceptionUpdatePayload = {
        status: constants.activityStatus.completed,
        updateTS: (new Date()).toISOString(),
        exceptionNote,
        isException: true
      }
      batch.update(refDoc,requestExceptionUpdatePayload)
    })
    // finally commiting the batch changes 
     await batch.commit()
   }
}

export const updateRequestData = async (requestId, data) => {
  await updateDoc(doc(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_REQUEST}`, requestId), data)
}

export const getGdeActivity = async (mode, val, selected, setData) => {
  const userval = getUser()
  const loggedInUserDistrict = selected ? selected : userval.district
  const conditions = []
  conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_JOB_REQUEST)
  let index = 0
  // conditions[++index] = where('srcSystem', '==', 'gde')
  if (
    val.status === constants.defaultSelect &&
    val.districts[0] === constants.defaultSelect
  ) {
    conditions[++index] = where('status', 'in', ['pending', 'In Progress'])
    conditions[++index] = where('district', '==', loggedInUserDistrict)
  } else {
    if (val.status !== constants.defaultSelect) {
      if (Array.isArray(val.status)) {
        conditions[++index] = where('status', 'in', val.status)
      } else {
        conditions[++index] = where('status', '==', val.status)
      }
      if (val.districts[0] === constants.defaultSelect) {
        conditions[++index] = where('district', '==', loggedInUserDistrict)
      }
    }
    if (val.districts[0] !== constants.defaultSelect) {
      conditions[++index] = where('district', 'in', val.districts)
      if (val.status === constants.defaultSelect) {
        conditions[++index] = where('status', 'in', ['pending', 'In Progress'])
      }
    }
  }

  const standTemplateQuery = query.apply(null, conditions)
  if (mode === 'normal') {
    return await getDocs(standTemplateQuery)
  } else if (mode === 'listener') {
    const unsubscribe = onSnapshot(standTemplateQuery, (snapshot) => {
      setData(snapshot)
    })
    return unsubscribe
  }
}

export const getrequestIdbydistandStatus = async (district, building, statuses) => {
  
  const results = await Promise.all(
    statuses.map(async (status) => {
      const statusKey = status;
      if (!statusKey) return { status, Filtereddocs: [], count: 0 };
      const conditions = []
      conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`)
      let index = 0
      if (district && district !== '') {
        conditions[++index] = where('district', '==', district)
      }
      if (building && building !== '') {
        conditions[++index] = where('building', '==', building)
      }
      if (statusKey && statusKey !== '') {
        conditions[++index] = where('status', '==', statusKey)
      }
      const standTemplateQuery = query.apply(null, conditions)  
      const querySnapshot = await getDocs(standTemplateQuery);

      return {
        status,
        Filtereddocs: querySnapshot.docs.map((doc) => doc.data()),
        count: querySnapshot.docs.length,
      };
    })
  ).catch((error) => {
    console.error('Error fetching data from Firestore:', error);
    throw error;
  });

  return results.reduce((acc, { status, Filtereddocs, count }) => {
    acc[status] = { count, Filtereddocs};
    return acc;
  }, {});
};
export const getImagesByDistrictandFormat = async (district, building) => {
  const conditions = []
  conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_JOB_IMAGES)
  let index = 0
  conditions[++index] = where('formatError', '==', true )
   if (district && district !== '') {
    conditions[++index] = where('district', '==', district)
  }
  if (building && building !== '') {
    conditions[++index] = where('building', '==', building)
  }
  const standTemplateQuery = query.apply(null, conditions)  
  const querySnapshot = await getDocs(standTemplateQuery);
  const images = querySnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
  }));

  return images;
};

export const getImagesByDistrictandFormatListener = async (setData, district, building) => {
  const conditions = []
  conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_JOB_IMAGES)
  let index = 0
  conditions[++index] = where('formatError', '==', true )
   if (district && district !== '') {
    conditions[++index] = where('district', '==', district)
  }
  if (building && building !== '') {
    conditions[++index] = where('building', '==', building)
  }
  const standTemplateQuery = query.apply(null, conditions)  
  
  const unsubscribe = onSnapshot(standTemplateQuery, (snapshot) => {
      const data = snapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data(),
  }))
  setData(data)
    })
    return unsubscribe
};

export const getRequestIdByDistAndStatusListener = (setData, district, building, statuses) => {
  const unsubscribeFunctions = [];

  statuses.forEach((status) => {
    if (!status) return;
    const conditions = []
    conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`)
    let index = 0
    if (district && district !== '') {
      conditions[++index] = where('district', '==', district)
    }
    if (building && building !== '') {
      conditions[++index] = where('building', '==', building)
    }
    if (status && status !== '') {
      conditions[++index] = where('status', '==', status)
    }
    const statusQuery = query.apply(null, conditions)
    const unsubscribe = onSnapshot(statusQuery, (snapshot) => {
      const filteredDocs = snapshot.docs.map((doc) => doc.data());
      
      const data = {
        status,
        Filtereddocs: filteredDocs,
        count: filteredDocs.length,
      };
      setData((prevState) => ({
        ...prevState,
        [status]: data,
      }));
    });

    unsubscribeFunctions.push(unsubscribe);
  });

  return () => unsubscribeFunctions.forEach((unsubscribe) => unsubscribe());
}

export const getCustomRequestNameById = async (requestId) => {
  const boxQuery = await getDoc(doc(firestore, 
    `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_REQUEST}`, 
    requestId)
  ) 
  // Return only the customRequestName from the document data
  return boxQuery.data()?.customRequestName 
}

export const getRequest = async (selectedDistrict) => {
  try {
    const userval = getUser()
    const userSelectedDistricts = (!selectedDistrict || selectedDistrict.length === 0) ? userval.district : selectedDistrict

    const standTemplateQuery = await getDoc(doc(collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_DASHBOARD}/${GDE_JOB_DISTRICT}/${GDE_JOB_DISTRICTSTAT}`), userSelectedDistricts))
    
    if (!standTemplateQuery.exists()) {
      console.error('Document does not exist')
      return null
    }

    const allDocs = standTemplateQuery.data().Data
    return allDocs

  } catch (error) {
    console.error('Error fetching request data:', error)
    return null
  }
}

export const getRequestsByDistrict = async(district, building) => {
  try {
    const conditions = []
    conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_JOB_REQUEST)
    let index = 0
    if (district && district !== '') {
      conditions[++index] = where('district', '==', district)
    }
    if (building && building !== '') {
      conditions[++index] = where('building', '==', building)
    }
    const standTemplateQuery = query.apply(null, conditions)
    return await getDocs(standTemplateQuery)
  } catch (error) {
    console.log('Error fetching requests by district data', error)
  }
}

export const getBoxTransmittalByDist = async (district, building) => {
  try {
    const conditions = []
    conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_SMART_CATALOG_TRANSMITTALS)
    let index = 0
    if (district && district !== '') {
      conditions[++index] = where('district', '==', district)
    }
    if (building && building !== '') {
      conditions[++index] = where('building', '==', building)
    }
    const standTemplateQuery = query.apply(null, conditions)
    return await getDocs(standTemplateQuery)
  } catch (error) {
    console.log('Error fetching requests by district data', error)
  }
}

export const createNewBoxLockField = async (jobId, boxId, data) => {
  return setDoc(doc(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}/${boxId}`), data)
}

export const getCustomerID = async () => {
  const boxQuery = query(
    collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SC_TEMPLATE}`)
  )
  return getDocs(boxQuery)
}

export const getTemplatesListener = async (formValues, mode, setData) => {
  const conditions = []
  const templateType = formValues?.templateType
  const assetType = formValues?.assetType
  const wmsInstance = formValues?.wmsInstance
  const accountLevel1 = formValues?.accountLevel1
  const accountLevel2 = formValues?.accountLevel2
  const accountLevel3 = formValues?.accountLevel3
  conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_SC_TEMPLATE)
  let index = 0
  // conditions[++index] = where('srcSystem', '==', 'gde')
  // conditions[++index] = where('isTemplate', '==', true)
  conditions[++index] = where('isActive', '==', true)
  if (accountLevel1 !== '') {
    conditions[++index] = where('accountLevel1', '==', accountLevel1.toUpperCase())
  }
  if (accountLevel2 !== '') {
    conditions[++index] = where('accountLevel2', '==', accountLevel2.toUpperCase())
  }
  if (accountLevel3 !== '') {
    conditions[++index] = where('accountLevel3', '==', accountLevel3.toUpperCase())
  }

  if (wmsInstance !== '' && wmsInstance !== undefined) {
    const templateName = getStandardTemplateName(wmsInstance, templateType, assetType)
    conditions[++index] = where('templateName', '==', templateName)
  } 
  if (assetType && assetType !== constants.defaultSelect && assetType !== '') {
    conditions[++index] = where('assetType', '==', assetType)
  }
  if (templateType && templateType !== constants.defaultSelect && templateType !== '') {
    conditions[++index] = where('templateType', '==', templateType)
  }
  const standTemplateQuery = query.apply(null, conditions)

  if (mode === 'normal') {
    return await getDocs(standTemplateQuery)
  } else if (mode === 'listener') {
    const unsubscribe = onSnapshot(standTemplateQuery, (snapshot) => {
      setData(snapshot)
    })
    return unsubscribe
  }
}

// 1227: Response Details for each box which are published and Processed
export const getSelectedResponse = async (activityId, total) => {
  let collectionImg
  if (total) {
    collectionImg = query(collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`), where('requestId', '==', activityId))
  } else {
    collectionImg = query(collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`), where('activityId', '==', activityId), orderBy('createTS', 'asc'))
  }
  const imageSnapshot = await getDocs(collectionImg)
  const imageData = imageSnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }))
  return imageData
}

// 1330: ResponseDetails for Transmittals
export const getSelectedFormat = async (transmittalId) => {
  const collectionData = query(collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_TRANSMITTALS}`), where('id', '==', transmittalId))
  const transmittalSnapshot = await getDocs(collectionData)
  const transmittalData = transmittalSnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }))
  return transmittalData
}
export const getImagesFormat = async (imageID) => {
  const collectionData = query(collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_JOB_IMAGES}`), where('id', '==', imageID))
  const imageSnapshot = await getDocs(collectionData)
  const imageData = imageSnapshot.docs.map(doc => ({
    id: doc.id,
    ...doc.data()
  }))
  return imageData
}

export const serialListner = async (setData, jobId) => {
  const collectionRef = collection(firestore, `${GDE_JOB}/${jobId}/${GDE_JOB_BOXES}`)
  const querySnapshot = query(collectionRef, where('jobId', '==', jobId))
  const jobData = onSnapshot(querySnapshot, (snapshot) => {
    const updatedData = snapshot.docs.map(doc => ({
      ...doc.data()
    }))
    setData(updatedData)
  })
  return jobData
}

export const getCustomerIdForBoxTrans = async () => {
  const boxQuery = query(
    collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}/${GDE_SMART_CATALOG_TRANSMITTALS}`)
  )
  return getDocs(boxQuery)
}
export const getBoxTransmittalsExcepDetail = async (exceptionType, district, building) => {
  const conditions = []
  conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_SMART_CATALOG_TRANSMITTALS)
  let index = 0
  if (district && district !== '') {
    conditions[++index] = where('district', '==', district)
  }
  if (building && building !== '') {
    conditions[++index] = where('building', '==', building)
  }
  if(exceptionType === 'format')
    conditions[++index] = where('formatError', '==', true)
  if(exceptionType === 'failed')
    conditions[++index] = where('status', '==', 'failed')

  const standTemplateQuery = query.apply(null, conditions)
  return await getDocs(standTemplateQuery)
  
}
export const getBoxTransmittalsListener = async (mode, val, setData) => {
  const userval = getUser()
  const loggedInUserDistrict = userval.district
  const conditions = []
  conditions[0] = collection(firestore, `${GDE_JOB_ACTIVITY}/${GDE_JOB_SMART_CATALOG}`, GDE_SMART_CATALOG_TRANSMITTALS)
  let index = 0

  // conditions[++index] = where('isActive', '==', true)
  if (
    val.status === constants.defaultSelect &&
    val.districts[0] === constants.defaultSelect
  ) {
    conditions[++index] = where('status', 'in', ['pending', 'published'])
    conditions[++index] = where('district', '==', loggedInUserDistrict)
  } else {
    if (val.status !== constants.defaultSelect) {
      if (Array.isArray(val.status)) {
        conditions[++index] = where('status', 'in', val.status)
      } else {
        conditions[++index] = where('status', '==', val.status)
      }
      if (val.districts[0] === constants.defaultSelect) {
        conditions[++index] = where('district', '==', loggedInUserDistrict)
      }
    }
    if (val.districts[0] !== constants.defaultSelect) {
      conditions[++index] = where('district', 'in', val.districts)
      if (val.status === constants.defaultSelect) {
        conditions[++index] = where('status', 'in', ['pending', 'published'])
      }
    }
  }

  const standTemplateQuery = query.apply(null, conditions)

  if (mode === 'normal') {
    return await getDocs(standTemplateQuery)
  } else if (mode === 'listener') {
    const unsubscribe = onSnapshot(standTemplateQuery, (snapshot) => {
      setData(snapshot)
    })
    return unsubscribe
  }
}

export const getfederalCustomersForExclusionListener = (mode, setData) => {
  const collectionRef = collection(firestore, `${CONFIG}/gde/federalCustomers`)
  if (mode === 'normal') {
    return getDocs(collectionRef)
  } else if (mode === 'listener') {
    const unsubscribe = onSnapshot(collectionRef, (snapshot) => {
      setData(snapshot)
    })
    return unsubscribe
  }
}

export const createFederalCustomerExclusion = async (data) => {
  const accountLevel1 = (data.accountLevel1 || '').trim()
  const accountLevel2 = (data.accountLevel2 || '').trim()
  const accountLevel3 = (data.accountLevel3 || '').trim()
  const docId =
    accountLevel2 === '' && accountLevel3 === ''
      ? accountLevel1
      : [accountLevel1, accountLevel2, accountLevel3].join('|')
  const docRef = doc(firestore, `${CONFIG}/gde/federalCustomers`, docId)
  await setDoc(docRef, { ...data, accountLevel1, accountLevel2, accountLevel3 })
  return docId
}

export const updateFederalCustomerExclusion = async (documentId, data) => {
  const exactPath = doc(firestore,`${CONFIG}/gde/federalCustomers`,documentId);
  return updateDoc(exactPath, data);
}


// export const checkUserPermissions = async (userId) => {
//   try {
//     // Check if user has gdeRole === "SUPER USER"
//     const gdeWorkerDetails = await getGdeWorkerDetails(userId)
//     const gdeData = gdeWorkerDetails.data()

//     if (!gdeData || (gdeData.gdeRole !== "SUPER USER" && gdeData.gdeRole !== "Super User")) {
//       return false
//     }

//     const imTimeWorkerDetails = await getIMTWorkerDetails(userId)
//     const imtData = imTimeWorkerDetails.data()

//     let hasAdminRole = false
//       if (imtData.role === "Admin") {
//         hasAdminRole = true
//       }

//     return hasAdminRole
//   } catch (error) {
//     console.error('Error checking user permissions:', error)
//     return false
//   }
// }

// This function can be used to update a whole collection based on new requirement such as add new key: value
// export const copyFieldsToNewCollection = async () => {
//   const sourceCollectionRef = collection(firestore, GDE_JOB)
//   try {
//     const job = await getDocs(sourceCollectionRef)

//     let batch = writeBatch(firestore)
//     let writeCount = 0
//     let counter = 0
//     let counter2 = 0
//     // Iterate over each document
//     job.forEach(async (docs) => {
//       // Get the data from the source document
//       console.log(++counter)
//       const data = docs.data()
//       if (data.accountLevel1 === 'SKA8P') {
//         return
//       }
        
//       const { autoTransmit, boxesCompleted, createdTs, dataEntryType, jobId, jobStatus, orderNumber, targetDate, totalBoxes, accountLevel1, districtId, assignedUserList, templateName } = data
//       const obj = data.assignedUsers
//       const names = []
//       for (const key in obj) {
//         if (obj[key].workerName !== undefined && obj[key].jobCategory.includes('Data Entry User')) {
//           names.push(obj[key].workerName)
//         }
//       }
//       const newData = {
//         autoTransmit: autoTransmit === undefined ? false : autoTransmit, 
//         boxesCompleted: boxesCompleted === undefined ? 0 : boxesCompleted,
//         createdTs: createdTs, 
//         dataEntryType: dataEntryType, 
//         jobId: jobId, 
//         jobStatus: jobStatus, 
//         orderNumber: orderNumber, 
//         targetDate: targetDate, 
//         totalBoxes: totalBoxes, 
//         workerName: names,
//         districtId: districtId, 
//         accountLevel1: accountLevel1,
//         assignedUserList: assignedUserList === undefined ? [] : assignedUserList,
//         templateName: templateName, 
//       }
//       console.log(jobId, newData)
        
//       if (jobId !== undefined && jobStatus === 'Transmitted') {
//         const collectionRef = collection(firestore, 'gdeJobTable')
//         const createFileRef = doc(collectionRef, jobId)
//         batch.set(createFileRef, newData)
//         console.log(createFileRef)
//         writeCount++
//         console.log(++counter2)
//       }

//       // Commit the batch if it reaches the limit of 500 writes
//       if (writeCount === 500) {
//         batch.commit()
//         // Reset the batch and write count
//         batch = writeBatch(firestore)
//         writeCount = 0
//       }
//     })

//     // Commit the remaining writes in the batch
//     if (writeCount > 0) {
//       batch.commit()
//     }

//     console.log('Fields copied successfully.')
//   } catch (error) {
//     console.error('Error copying fields:', error)
//   }
// }
